import { http } from "../../../shared/api/http"

export type ReviewType = "course" | "enterprise" | "market"

export interface AdminReviewItem {
  id: string
  type: ReviewType
  target_id: string
  target_name: string | null
  user_id: string
  rating: number
  comment: string
  tags: string[]
  created_at: number
}

export interface AdminListReviewsResponse {
  items: AdminReviewItem[]
  total: number
}

export type AdminReviewsFilters = {
  type: ReviewType
  target_id?: string
  limit?: number
  offset?: number
}

export const listAdminReviewsApi = (filters: AdminReviewsFilters) =>
  http.get<AdminListReviewsResponse>("/api/admin/reviews", { params: filters })

export const deleteAdminReviewApi = (type: ReviewType, reviewId: string) =>
  http.delete<{ success: boolean }>(`/api/admin/reviews/${type}/${reviewId}`)